import { ArrowLeft, User, MoreVertical } from "lucide-react";
import { Button } from "../../tailwind/button";

export default function ChatHeader({ chat, onBack, onClose, onResolve }) {
  const hasName = Boolean(chat?.customerName);
  const avatarInitial = hasName ? chat?.name?.trim()?.charAt(0)?.toUpperCase() : null;

  return (
    <div className="h-16 border-b border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between px-4 shrink-0 shadow-sm z-10">
      <div className="flex items-center gap-3">
        <button
          type="button"
          className="md:hidden p-2 -ml-2 text-gray-500 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-full"
          onClick={onBack}
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
        <div className="h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 flex items-center justify-center font-medium">
          {avatarInitial ? (
            <span className="text-sm font-semibold">{avatarInitial}</span>
          ) : (
            <User className="h-4 w-4" />
          )}
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-slate-100">{chat?.name}</h2>
          {hasName && chat?.phone && (
            <p className="text-xs text-gray-500 dark:text-slate-400">{chat?.phone}</p>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          onClick={onResolve}
          className="text-[hsl(158,48%,28%)] dark:text-[hsl(158,45%,55%)] border-[hsl(158,48%,36%)]/30 dark:border-[hsl(158,48%,36%)]/40 bg-[hsl(158,48%,36%)]/10 dark:bg-[hsl(158,48%,36%)]/15 hover:bg-[hsl(158,48%,36%)]/20 dark:hover:bg-[hsl(158,48%,36%)]/25 h-9"
        >
          Resolve
        </Button>
        <Button variant="ghost" size="icon" className="h-9 w-9 text-gray-500 dark:text-slate-300">
          <MoreVertical className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
}
